import React, { useState } from "react";
import { Input, Button } from "antd";
import { Link, useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";
import Navbar from "../common/Navbar";
import { handleForgotPasswordSubmit } from "../../services/LoginService";
import { showErrorMessage, showSuccessMessage } from "../../utils";
import { BASE_IMG, LOGO_LOGIN_MAIN, LOGO_LOGIN_TEXT, BRAND_TAGLINE, BRAND_NAME } from "../../constants";
import "./style.css";

export default function ForgotPasswordComponent() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleContinue = async () => {
    if (!email) {
      return;
    }

    setIsSubmitting(true);
    const { success, message = "" } = await handleForgotPasswordSubmit(email);
    if (success) {
      showSuccessMessage(message || "Reset instructions have been sent to your email");
      navigate("/login");
    } else {
      showErrorMessage(message || "Unable to process request right now");
    }
    setIsSubmitting(false);
  };

  return (
    <>
      <Helmet>
        <title>{BRAND_NAME} - Forgot Password</title>
        <link rel="canonical" href="/forgot-password" />
      </Helmet>
      <div>
        <Navbar showSettings={false} />
        <div className="login">
          <div className="left-container">
            <img src={`${BASE_IMG}/login_left.svg`} height="95%" width="95%" />
          </div>
          <div className="right-container">
            <div className="right-subContainer">
              <div className="app-title-logo">
                <div className="app-logo">
                  <img src={LOGO_LOGIN_MAIN} height="100%" width="100%" />
                </div>
                {LOGO_LOGIN_TEXT ? (
                  <div className="app-title">
                    <img src={LOGO_LOGIN_TEXT} />
                  </div>
                ) : null}
              </div>
              <div className="app-motto-text">{BRAND_TAGLINE}</div>

              <div className="forgot-password-container auth-form-container">
                <div className="login-box-text">Reset password</div>
                <p className="forgot-password-subtext">
                  Enter your account email. We will send reset instructions.
                </p>
                <Input
                  className="login-box-input-container2"
                  id="forgot-email"
                  type="email"
                  value={email}
                  placeholder="Email"
                  onChange={(e) => setEmail(e.target.value)}
                />
                <Button
                  disabled={!email || isSubmitting}
                  className={`login-box-button-container-button ${!email || isSubmitting ? "disabled-button" : ""}`}
                  onClick={handleContinue}
                >
                  <div className="login-box-button-container-button-text">Continue</div>
                </Button>
                <p className="forgot-password-link">
                  <Link to="/login">Back to login</Link>
                </p>
                <p className="login-bottom-text-container-bottom auth-page-footer">
                  &copy; Copyright 2026 RazeHQ. All rights reserved.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
